export class ActivityInfo{
    id:number = -1;
    activityId:number = -1;
    name:string = "";
    activityText:string = "";
    categoryId:string|null = null;
    categoryTitle: string = "";
    iconName: string = "";
}